import '.i{position:fixed;}.ssr-plugin'
import '.bf{top:0px;}.ssr-plugin'
import '.bn{left:0px;}.ssr-plugin'
import '.bo{right:0px;}.ssr-plugin'
import '.bp{bottom:0px;}.ssr-plugin'
import '.bq{background-color:rgba(0, 0, 0, 0.25);}.ssr-plugin'
import '.br{z-index:998;}.ssr-plugin'
import '.bs{transition:opacity 0.3s ease;}.ssr-plugin'
import '.bt{height:100vh;}.ssr-plugin'
import '.l{width:100%;}.ssr-plugin'
import '.v{background-color:var(--palette-white);}.ssr-plugin'
import '.bu{transition:transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);}.ssr-plugin'
import '.bv{z-index:999;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.al{justify-content:space-between;}.ssr-plugin'
import '.bw{padding:1.5rem;}.ssr-plugin'
import '.bx{border-bottom:var(--border-default);}.ssr-plugin'
import '.ac{flex-shrink:0;}.ssr-plugin'
import '.ax{flex:1;}.ssr-plugin'
import '.by{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { IconButton } from '@app/components/core/button/IconButton'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { PropsWithChildren } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'

export interface DrawerProps extends PropsWithChildren {
  title: string
  open: boolean
  setOpen: (open: boolean) => void
  portal?: HTMLElement
  style?: Style
  side: 'left' | 'right'
}

export const Drawer = ({
  title,
  open,
  setOpen,
  children,
  portal: _portal,
  style,
  side,
}: DrawerProps) => {
  const isMobile = useMediaQuery()

  const translateValue = open ? '0' : side === 'left' ? '-100%' : '100%'

  return (
    <>
      {/* Overlay */}
      <div className="i bf bn bo bp bq br bs"
        onClick={() => setOpen(false)}
        style={{
          opacity: open ? 1 : 0,
          pointerEvents: open ? 'auto' : 'none',}}
      />

      {/* Sidebar Panel */}
      <styled.div className="i bf bt l v bu bv d e"
        style={{
          [side]: 0,
          maxWidth: isMobile ? '100%' : '30rem',
          borderRadius: isMobile ? 0 : '1.25rem',
          boxShadow: open ? '0 0 15px rgba(0,0,0,0.15)' : 'none',
          transform: `translateX(${translateValue})`,
          ...style,
        }}
      >
        {/* Header */}
        <div className="d t al bw bx ac"
        >
          <Title.H4 style={{ margin: 0 }}>{title}</Title.H4>
          <IconButton
            icon={faXmark}
            size="small"
            variant="secondary"
            onClick={() => setOpen(false)}
          />
        </div>

        {/* Content */}
        <div className="ax by bw"
        >
          {children}
        </div>
      </styled.div>
    </>
  )
}
